import { env } from "@/utils/envs";
import * as Sentry from "@sentry/react";

export function initSentry() {
  if (env.ENVIRONMENT === "production" && env.SENTRY_DSN) {
    Sentry.init({
      dsn: env.SENTRY_DSN,
      environment: env.ENVIRONMENT || "production",
      tracesSampleRate: 1.0,
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function captureException(error: any, context?: any) {
  Sentry.captureException(error, { extra: context });
}

export function captureMessage(
  message: string,
  level?: "debug" | "info" | "warning" | "error" | "fatal",
) {
  Sentry.captureMessage(message, level);
}

export function setUser(user: {
  id: string;
  email: string;
  username?: string;
}) {
  Sentry.setUser(user);
}

export function clearUser() {
  Sentry.setUser(null);
}
